import { connect } from 'react-redux';

import { cancelQuoteCompose } from 'flavours/glitch/actions/compose';

import ReplyIndicator from '../components/reply_indicator';

const makeMapStateToProps = () => {
  const mapStateToProps = state => {
    const statusId = state.getIn(['compose', 'quote_id']);

    return {
      status: statusId ? state.getIn(['statuses', statusId]) : null,
      editing: false,
    };
  };

  return mapStateToProps;
};

const mapDispatchToProps = dispatch => ({
  onCancel () {
    dispatch(cancelQuoteCompose());
  },
});

export default connect(makeMapStateToProps, mapDispatchToProps)(ReplyIndicator);
